function timestampToTime(timestamp, num = 6,format='-') {

    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear();
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    var D = date.getDate()< 10 ? '0' + date.getDate() : date.getDate();
    var h = date.getHours()< 10 ? '0' + date.getHours() : date.getHours();
    var m = date.getMinutes()< 10 ? '0' + date.getMinutes() : date.getMinutes();
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    var arr = [Y, format, M, format, D, ' ', h, ':', m, ':', s], time = '';

    for (let i = 0; i < 2 * num - 1; i++) {
        time += arr[i]

    }

    return time
}
function DaylastTime(timestamp,format='-'){
  let time=timestampToTime(timestamp,3,format)
  return new Date(time+' '+'23:59:59').getTime()
}
function everyTime(timestamp,SFM,format='-'){
  let time=timestampToTime(timestamp,3,format)
  return new Date(time+' '+SFM).getTime()
}
// 分页功能
function changePage(getAthletesList,Array){
  let pageTotal=Math.ceil((this.data.total/this.data.pageSize))
  console.log(pageTotal,this.data.pageNum)
  if(this.data.pageNum<pageTotal){
    this.setData({
      pageNum:this.data.pageNum+1
    })
    if(Array){
    this[getAthletesList](this.data.pageNum,this.data.pageSize,...Array)}
    else{
      this[getAthletesList](this.data.pageNum,this.data.pageSize)
    }
  } else{
    wx.showToast({
      title: '我已经到底了',
      icon:'none'
    })
  }
 
}
export {
    timestampToTime,
    DaylastTime,
    changePage,
    everyTime
}